import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { NavigationEnd, Router, RouterLink, RouterOutlet } from '@angular/router';
import { SessionMonitorService } from './security/session-monitor.service';
import { StorageService } from './services/storage.service';
import { Menu } from './models/LoggedUserInfo';
import { FullSpinnerService } from './services/full-spinner.service';
import { InitAppService } from './services/init-app.service';
import { AlertComponent } from './components/shared/alert/alert.component';
import { KeycloakService } from './services/keycloak.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, RouterLink, CommonModule, AlertComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  title = 'Safe Street';
  isAuthenticated = false;

  authenticatedUser = '';
  menu!: Menu[];
  currentMenu: string = '';

  loadingMessage: string | undefined = '';
  loading: boolean = false;

  sideToShow = 'active';
  overlayToShow = 'd-none';


  constructor(
    private sessionMonitor: SessionMonitorService,
    private keycloakService: KeycloakService,
    private storageService: StorageService,
    private fullSpinnerService: FullSpinnerService,
    private router: Router
  ) {
    this.isAuthenticated = storageService.isAuthenticated();
    if (storageService.isAuthenticated()) {
      this.initAuthUser();
    }

    this.sessionMonitor
      .sessionMonitor()
      .pipe()
      .subscribe((isAuthenticated) => {
        this.currentMenu = '';
        this.isAuthenticated = isAuthenticated;
        if (isAuthenticated) {
          this.initAuthUser();
        }
      });

    this.fullSpinnerService
      .getMessage()
      .pipe()
      .subscribe((message) => {
        setTimeout(() => {
          this.loadingMessage = message;
          this.loading = message !== undefined;
        }, 100);
      });

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        let currentMenu = event.url.replace(/\//g, '');
        if (currentMenu === '') {
          this.overlayToShow = '';
          this.sideToShow = 'slide-none';
        }
        

      }
    });
  }

  private initAuthUser() {
    this.loadMenu();
  }

  private loadMenu() {
    const loggedUser = this.storageService.getLoggedUser();
    if (!loggedUser) {
      return;
    }
    this.menu = loggedUser.menu;
    if (this.menu) {
      let countRoute = 0;
      let onlyRoute = '';
      countRoute += this.menu.filter((m) => m.page).length;
      if (countRoute === 1) onlyRoute = this.menu.filter((m) => m.page)[0].page;
      this.menu.forEach((sm) => {
        if (sm.childMenus) {
          let c = sm.childMenus.filter((sm) => sm.page);
          countRoute += c.length;
          if (c.length === 1) onlyRoute = c[0].page;
        }
      });
      this.authenticatedUser = loggedUser.username;
    }

    const currentSelectedMenu = this.storageService.getValue('current_selected_menu');
    const selectedMenu = currentSelectedMenu || { name: '' };
    if (selectedMenu?.name) {
      this.openMenu(selectedMenu);
      this.currentMenu = selectedMenu.name
    }
    this.router.navigate([selectedMenu?.page || '']);
  }

  logout() {
    this.keycloakService.logout();
  }

  shoHideMenu() {
    this.overlayToShow = '';
    this.sideToShow = this.sideToShow === 'active' ? 'slide-none' : 'active';
  }

  openDashboard() {
    this.currentMenu = '';
    this.fullSpinnerService.spinner('');
    this.router.navigate(['/']);
  }

  openMenu(menu_item: Menu) {


    this.fullSpinnerService.spinner('');
    this.storageService.setValue('current_selected_menu', menu_item);
     this.currentMenu = menu_item.name
    this.router.navigate([menu_item.page]);

  }

  shoHideOverlay() {
    this.overlayToShow = 'd-none';
    this.sideToShow = '';
  }
}
